module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "id": "p9000f15f9970005001"
    }
  }), _c('h2', {
    staticClass: "chapter-title"
  }, [_c('em', [_vm._v("Contents")])]), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  })]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('a', {
    attrs: {
      "href": "#/ch006#p9000f15f9970006001"
    }
  }, [_c('strong', [_vm._v("Introduction")])]), _c('a', {
    attrs: {
      "href": "#/ch006#p9000f15f9970006001"
    }
  }, [_c('strong', [_vm._v("6")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('a', {
    attrs: {
      "href": "#/ch007#p9000f15f9970008001"
    }
  }, [_c('strong', [_vm._v("Beads")])]), _c('a', {
    attrs: {
      "href": "#/ch007#p9000f15f9970008001"
    }
  }, [_c('strong', [_vm._v("8")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('a', {
    attrs: {
      "href": "#/ch008#p9000f15f9970012001"
    }
  }, [_c('strong', [_vm._v("Tools and Equipment")])]), _c('a', {
    attrs: {
      "href": "#/ch008#p9000f15f9970012001"
    }
  }, [_c('strong', [_vm._v("12")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('a', {
    attrs: {
      "href": "#/ch009#p9000f15f9970016001"
    }
  }, [_c('strong', [_vm._v("Techniques")])]), _c('a', {
    attrs: {
      "href": "#/ch009#p9000f15f9970016001"
    }
  }, [_c('strong', [_vm._v("16")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  })]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('a', {
    attrs: {
      "href": "#/ch010#p9000f15f9970018001"
    }
  }, [_c('strong', [_vm._v("1")])]), _c('a', {
    attrs: {
      "href": "#/ch010#p9000f15f9970018001"
    }
  }, [_c('em', [_vm._v("Bead Loom Weaving")])]), _c('a', {
    attrs: {
      "href": "#/ch010#p9000f15f9970018001"
    }
  }, [_vm._v(" 18")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('span', {
    attrs: {
      "href": "#/ch018#p9000f15f9970155001",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("2")])]), _c('span', {
    attrs: {
      "href": "#/ch018#p9000f15f9970155001",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("OffLoom Bead Stitches")])]), _c('span', {
    attrs: {
      "href": "#/ch018#p9000f15f9970155001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 34")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('span', {
    attrs: {
      "href": "#/ch012#p9000f15f9970062001",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("3")])]), _c('span', {
    attrs: {
      "href": "#/ch012#p9000f15f9970062001",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Ropes and Cords")])]), _c('span', {
    attrs: {
      "href": "#/ch012#p9000f15f9970062001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 62")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('span', {
    attrs: {
      "href": "#/ch013#p9000f15f9970076001",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("4")])]), _c('span', {
    attrs: {
      "href": "#/ch013#p9000f15f9970076001",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Fringing, Nett ing and Tassels")])]), _c('span', {
    attrs: {
      "href": "#/ch013#p9000f15f9970076001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 76")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('span', {
    attrs: {
      "href": "#/ch014#p9000f15f9970090001",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("5")])]), _c('span', {
    attrs: {
      "href": "#/ch014#p9000f15f9970090001",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Threading and Stringing")])]), _c('span', {
    attrs: {
      "href": "#/ch014#p9000f15f9970090001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 90")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('span', {
    attrs: {
      "href": "#/ch015#p9000f15f9970106001",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("6")])]), _c('span', {
    attrs: {
      "href": "#/ch015#p9000f15f9970106001",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Wire Work and Jewellery Techniques")])]), _c('span', {
    attrs: {
      "href": "#/ch015#p9000f15f9970106001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 106")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('span', {
    attrs: {
      "href": "#/ch016#p9000f15f9970124001",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("7")])]), _c('span', {
    attrs: {
      "href": "#/ch016#p9000f15f9970124001",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Bead Embroidery")])]), _c('span', {
    attrs: {
      "href": "#/ch016#p9000f15f9970124001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 124")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('span', {
    attrs: {
      "href": "#/ch017#p9000f15f9970136001",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("8")])]), _c('span', {
    attrs: {
      "href": "#/ch017#p9000f15f9970136001",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Knitt ing and Crochet")])]), _c('span', {
    attrs: {
      "href": "#/ch017#p9000f15f9970136001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 136")])])])]), _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  })]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('span', {
    attrs: {
      "href": "#/ch018#p9000f15f9970152001",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Project Instructions: Bead Something Now")])]), _c('span', {
    attrs: {
      "href": "#/ch018#p9000f15f9970152001",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("152")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('span', {
    attrs: {
      "href": "#/ch019#p9000f15f9970173001",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Bead Charts")])]), _c('span', {
    attrs: {
      "href": "#/ch019#p9000f15f9970173001",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("173")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('span', {
    attrs: {
      "href": "#/ch020#p9000f15f9970174001",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Bead Product Details")])]), _c('span', {
    attrs: {
      "href": "#/ch020#p9000f15f9970174001",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("174")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('span', {
    attrs: {
      "href": "#/ch021#p9000f15f9970175003",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Suppliers")])]), _c('span', {
    attrs: {
      "href": "#/ch021#p9000f15f9970175003",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("175")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('span', {
    attrs: {
      "href": "#/ch022#p9000f15f9970176001",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Index")])]), _c('span', {
    attrs: {
      "href": "#/ch022#p9000f15f9970176001",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("176")])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c343e2e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch005.vue
// module id = 72
// module chunks = 0